<template>
<v-main>
  <v-layout row wrap>
    <v-flex xs12 class="ma-2 mx-5">
      <v-card class="mx-auto rounded-xl px-5">
        <v-layout row wrap justify-center>
          <v-flex @click="mudarTabelaPeloTipo(4)" pa-1 hover xs sm1>
            <v-card hover dark :color="intFuncionarioOnline == 4 ? 'cyan darken-2': 'grey'" class="text-center">
              <v-card-text class="px-0"><strong>Médico</strong></v-card-text>
            </v-card>
          </v-flex>
          <v-flex @click="mudarTabelaPeloTipo(2)" pa-1 xs sm1>
            <v-card hover dark :color="intFuncionarioOnline == 2 ? 'cyan darken-2': 'grey'" class="text-center">
              <v-card-text class="px-0"><strong>Recepcionista</strong></v-card-text>
            </v-card>
          </v-flex>
          <v-flex @click="mudarTabelaPeloTipo(3)" pa-1 hover xs sm1>
            <v-card hover dark :color="intFuncionarioOnline == 3 ? 'cyan darken-2': 'grey'" class="text-center">
              <v-card-text class="px-0"><strong>Atendente</strong></v-card-text>
            </v-card>
          </v-flex>
          <v-flex @click="mudarTabelaPeloTipo(6)" pa-1 hover xs sm1 class="text-center">
            <v-card hover dark :color="intFuncionarioOnline == 6 ? 'cyan darken-2': 'grey'">
              <v-card-text class="px-0"><strong>Painel</strong></v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex sm12>
          <v-divider />

              <v-card-title>
                <v-toolbar-title>Funcionários Online</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table no-data-text="Não há funcionários desse tipo Online" :headers="headers" :items="listaFuncionariosTabela" :search="search">
                <!-- <template v-slot:items="props">
                  <td class="title">{{ props.item.nome }}</td>
                  <td class="title">{{ tipo }}</td>
                  <td class="title">{{ props.item.nomeLocal }}</td>
                </template> -->
                <template v-slot:no-results>
                  <v-alert dark rounded :value="true" color="error" icon="warning">Sua busca por "{{ search}}" não encontrou resultados.</v-alert>
                </template>
              </v-data-table>
            
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</v-main>
</template>

<script>
import administradorUnidadeService from '../../services/administradorUnidade.service'

export default {
  name: 'funcionariosOnline',
  data() {
    return {
      page: 1,
      search: '',
      intFuncionarioOnline: 1,
      qtdVagasVazio: false,
      servicosQueSeraoMandados: '',
      listaServicos: [],
      tipo: '',
      diaSemanaLista: '',
      dialogErroQuantidade: false,
      listaFuncionariosTabela: [],
      listaFuncionarios: [],
      respostaServidor: false,
      isEditing: true,
      dialog2: false,
      headers: [{
          text: 'Nome do Funcionário',
          align: 'center',
          value: 'nome'
        },
        // {
        //   text: 'Função',
        //   value: 'tipo',
        //   align: 'center'
        // },
        {
          text: 'Local',
          value: 'nomeLocal',
          align: 'center'
        }
        // { text: 'Função', value: 'quantVagas', align: 'center', sortable: true },
      ],
      listaAdministradores: [],
      user: null,
      items: [{
          nomeEspecialidade: 'Cardiologia',
          idServico: '1',
          quantVagas: 1,
          idLocal: 1
        },
        {
          nomeEspecialidade: 'Urologia',
          idServico: '3',
          quantVagas: 2,
          idLocal: 2
        },
        {
          nomeEspecialidade: 'Cirugia',
          idServico: '2',
          quantVagas: 10,
          idLocal: 3
        },
        {
          nomeEspecialidade: 'Ultrasom',
          idServico: '15',
          quantVagas: 10,
          idLocal: 4
        },
        {
          nomeEspecialidade: 'Cirugia 3',
          idServico: '31',
          quantVagas: 11,
          idLocal: 5
        },
        {
          nomeEspecialidade: 'Cirugia 4',
          idServico: '22',
          quantVagas: 11,
          idLocal: 6
        }
      ]
    }
  },
  props: {
    msg: String
  },
  mounted() {
    console.log('em servicos unidade...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarFuncionariosOnline()
  },

  methods: {
    mudarTabelaPeloTipo(tipo) {
      this.intFuncionarioOnline = tipo
      if (tipo == 4) {
        this.tipo = 'Médico'
      }
      if (tipo == 2) {
        this.tipo = 'Recepcionista'
      }
      if (tipo == 3) {
        this.tipo = 'Atendente'
      }
      if (tipo == 6) {
        this.tipo = 'Painel'
      }
      console.log('em mudar tabela')
      this.listaFuncionariosTabela = this.listaFuncionarios.filter(person => {
        return person.tipo == tipo
      })
      // fazer funcao que filtra pelo tipo aquiiiiiii
      // console.log(teste)
    },

    retornarFuncionariosOnline() {
      administradorUnidadeService.administradorUnidade
        .retornarFuncionariosOnline()
        .then(rsp => {
          console.log('rsp oi, func online:', rsp.data)
          this.listaFuncionarios = rsp.data
          this.listaFuncionariosTabela = this.listaFuncionarios.filter(
            person => {
              return person.tipo == 4
            }
          )
          this.listaFuncionariosTabela.forEach(e => {
          });
          this.tipo = 'Médico'
          this.intFuncionarioOnline = 4
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }
  },

  created() {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
